import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LawfulBasis } from '../Constants';
import LegalBasisTooltipContent from './LegalBasisTooltipContent';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = ({
  hideConsent = false,
  hideContract = false,
  showHelpText = false,
  hideNonGdpr = false
}) => {
  const options = [Object.assign({
    text: I18n.text(`options.lawfulBasis.${LawfulBasis.LEGITIMATE_INTEREST_PQL}`),
    value: LawfulBasis.LEGITIMATE_INTEREST_PQL
  }, showHelpText && {
    help: I18n.text(`options.lawfulBasis.help.${LawfulBasis.LEGITIMATE_INTEREST_PQL}`)
  }), Object.assign({
    text: I18n.text(`options.lawfulBasis.${LawfulBasis.LEGITIMATE_INTEREST_CLIENT}`),
    value: LawfulBasis.LEGITIMATE_INTEREST_CLIENT
  }, showHelpText && {
    help: I18n.text(`options.lawfulBasis.help.${LawfulBasis.LEGITIMATE_INTEREST_CLIENT}`)
  }), Object.assign({
    text: I18n.text(`options.lawfulBasis.${LawfulBasis.LEGITIMATE_INTEREST_OTHER}`),
    value: LawfulBasis.LEGITIMATE_INTEREST_OTHER
  }, showHelpText && {
    help: I18n.text(`options.lawfulBasis.help.${LawfulBasis.LEGITIMATE_INTEREST_OTHER}`)
  })];
  if (!hideContract) {
    options.push(Object.assign({
      text: I18n.text(`options.lawfulBasis.${LawfulBasis.PERFORMANCE_OF_CONTRACT}`),
      value: LawfulBasis.PERFORMANCE_OF_CONTRACT
    }, showHelpText && {
      help: I18n.text(`options.lawfulBasis.help.${LawfulBasis.PERFORMANCE_OF_CONTRACT}`)
    }));
  }
  if (!hideConsent) {
    options.push(Object.assign({
      text: I18n.text(`options.lawfulBasis.${LawfulBasis.CONSENT_WITH_NOTICE}`),
      value: LawfulBasis.CONSENT_WITH_NOTICE
    }, showHelpText && {
      help: I18n.text(`options.lawfulBasis.help.${LawfulBasis.CONSENT_WITH_NOTICE}`)
    }));
  }
  if (!hideNonGdpr) {
    options.push(Object.assign({
      text: I18n.text(`options.lawfulBasis.${LawfulBasis.NON_GDPR}`),
      value: LawfulBasis.NON_GDPR
    }, showHelpText && {
      help: I18n.text(`options.lawfulBasis.help.${LawfulBasis.NON_GDPR}`)
    }));
  }
  return options;
};
const LawfulBasisSelect = props => {
  return /*#__PURE__*/_jsx(FormControl, Object.assign({
    label: I18n.text('labels.lawfulBasis'),
    tooltip: /*#__PURE__*/_jsx(LegalBasisTooltipContent, {})
  }, props.formControlProps, {
    children: /*#__PURE__*/_jsx(Select, Object.assign({
      placeholder: I18n.text('placeholders.lawfulBasis')
    }, props, {
      options: getOptions(props),
      "data-selenium-test": "gdpr-legal-basis-select"
    }))
  }));
};
export default LawfulBasisSelect;